import React, { createContext, useContext } from 'react';

type ProfileContextType = {
  profileData: any | null;
  setProfileData: (data: any) => void;
  isDomainAllowed: boolean;
  userDomain: string | null;
};

export const ProfileContext = createContext<ProfileContextType | undefined>(undefined);

export const useProfile = () => {
  const context = useContext(ProfileContext);
  if (!context) {
    throw new Error('useProfile must be used within a ProfileProvider');
  }
  return context;
};